import DataRequest from "./DataRequest";
import { useQuery } from "react-query";
import { Defect, NotableItem } from "../types/responses/gradingResponse";

export const getNotableItems = (inspectionId: string) => {
    return useQuery<NotableItem[] | Defect[]>("notableItems", async () => {
        return await DataRequest(inspectionId, "notable-items");
    });
};
